import { CardItem } from './card-item';
import { CardItemActions } from './card-item-actions';
import { CardItemTitle } from './card-item-title';

export const CardItemImports = [CardItem, CardItemActions, CardItemActions, CardItemTitle];
